import React from 'react';
import { BadgeCheck, Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'MG',
  name: 'M.G.',
  role: 'Contador Público, Buenos Aires',
  text: 'La verdad entré con bastante escepticismo porque ya había comprado cosas parecidas que no me sirvieron. Lo que me cambió fue el módulo de comunicación — específicamente la parte de cómo responder cuando te piden descuento. Tuve esa conversación tres veces en el mismo mes y las tres veces sostuve el precio. Dos cerraron igual.'
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'Diseñadora Gráfica, Rosario',
  text: 'Todavía estoy implementando todo, no terminé los tres bonos. Pero solo con la guía de estructura ya reorganicé cómo presento mis proyectos. Antes mandaba un PDF con el precio al final. Ahora presento el alcance primero y el precio cierra solo. No sé si voy a duplicar honorarios, pero ya cobré un 30% más en dos proyectos seguidos.'
}, {
  initials: 'RM',
  name: 'R.M.',
  role: 'Coach Ejecutivo, CABA',
  text: 'Mi problema no era cobrar poco, era que no entendía por qué algunos meses me iba bien y otros no. Con el módulo de organización financiera mapeé todo y encontré que estaba perdiendo plata en clientes de pocas horas. Los reorganicé o los aumenté. En dos meses la facturación subió sin sumar más clientes.'
}, {
  initials: 'LP',
  name: 'L.P.',
  role: 'Consultora de RRHH, Córdoba',
  text: 'Lo que más me costaba era la reunión donde el cliente dice “lo tengo que pensar”. Siempre terminaba bajando el precio para cerrar. Con los scripts del bono 2 ensayé respuestas concretas — me sentí un poco tonta haciéndolo sola en casa pero funcionó. La siguiente reunión así la cerré al precio original.'
}, {
  initials: 'FT',
  name: 'F.T.',
  role: 'Arquitecto independiente, Mendoza',
  text: 'Compré el pack completo con casos. Los casos me sirvieron más de lo que esperaba — no para copiar sino para ver que el problema que yo tenía lo habían resuelto otros. Eso solo ya justificó el precio.'
}, {
  initials: 'SV',
  name: 'S.V.',
  role: 'Abogada, Rosario',
  text: 'En tres semanas definí mis paquetes de servicio y dejé de cotizar por hora. Eso fue lo más concreto que me llevé. El resto lo sigo aplicando.'
}];
export function MoreTestimonials() {
  return <section className="bg-brand-lighter px-6 py-24 lg:px-8" data-id="element-160">
      <div className="mx-auto max-w-6xl" data-id="element-161">
        <header className="mx-auto mb-12 max-w-3xl text-center" data-id="element-162">
          <h2 className="text-3xl font-extrabold text-brand-navy md:text-5xl" data-id="element-163">
            Lo que dicen quienes ya lo aplicaron
          </h2>
          <p className="mt-4 text-lg text-brand-navy/65" data-id="element-164">
            Experiencias concretas de profesionales que están ordenando su forma
            de trabajar.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-165">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06
        }} className="rounded-2xl border border-brand-light bg-white p-6 shadow-soft" data-id="element-166">
              <div className="mb-5 flex items-start gap-4" data-id="element-167">
                <div aria-hidden="true" className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-accent text-sm font-extrabold text-white" data-id="element-168">
                  {testimonial.initials}
                </div>

                <div className="min-w-0" data-id="element-169">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-170">
                    <h3 className="font-extrabold text-brand-navy" data-id="element-171">
                      {testimonial.name}
                    </h3>
                    <span className="text-sm text-brand-navy/60" data-id="element-172">
                      — {testimonial.role}
                    </span>
                  </div>
                  <div className="mt-1 flex items-center gap-2" data-id="element-173">
                    <div className="flex gap-0.5" aria-label="Calificación 5 de 5" data-id="element-174">
                      {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" data-id="element-175" />)}
                    </div>
                    <span className="flex items-center gap-1 text-xs font-bold text-brand-green" data-id="element-176">
                      <BadgeCheck className="h-3.5 w-3.5" data-id="element-177" />
                      Compra verificada
                    </span>
                  </div>
                </div>
              </div>

              <p className="text-sm leading-relaxed text-brand-navy/80" data-id="element-178">
                “{testimonial.text}”
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}